import {isFinanceSelfEmploymentFlow} from './statusConnectionFlow';
import {getSelfEmploymentStatusLabel} from './workStatus';
import {RegistrationWorkStatus} from './types';

export const MY_TAX_SUCCESS_TITLE = 'Отлично!';

export const MY_TAX_SUCCESS_DESCRIPTION_BY_STATUS: Record<RegistrationWorkStatus, string> = {
	self_employment: 'Всё получилось, теперь вы можете работать как самозанятый',
	individual: 'Всё получилось, теперь вы можете работать как физическое лицо',
	individual_entrepreneur: 'Всё получилось, ваше ИП подключено к сервису',
};

export const getMyTaxSuccessTitle = (): string => MY_TAX_SUCCESS_TITLE;

export const getMyTaxSuccessDescription = (workStatus: RegistrationWorkStatus | null): string => {
	if (isFinanceSelfEmploymentFlow(workStatus)) {
		return `Статус «${getSelfEmploymentStatusLabel()}» указан в вашем профиле.`;
	}

	if (!workStatus) {
		return MY_TAX_SUCCESS_DESCRIPTION_BY_STATUS.self_employment;
	}

	return MY_TAX_SUCCESS_DESCRIPTION_BY_STATUS[workStatus];
};
